import React from 'react';
import { Dialog, T } from '@colonist/ui';
/** Dialog to show profile or kick options to the host for a guest. */ export function HostActionOnGuestDialog({ open, onClose, username, onKick, onViewProfile }) {
    const handleKick = ()=>{
        onKick();
        onClose();
    };
    const handleViewProfile = ()=>{
        onViewProfile();
        onClose();
    };
    return /*#__PURE__*/ React.createElement(Dialog, {
        open: open,
        onClose: onClose
    }, /*#__PURE__*/ React.createElement(Dialog.Title, null, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:roomPage.hostActions.title'
        }
    })), /*#__PURE__*/ React.createElement(Dialog.Content, null, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:roomPage.hostActions.body',
            options: {
                username: username
            }
        }
    })), /*#__PURE__*/ React.createElement(Dialog.ButtonFooter, null, /*#__PURE__*/ React.createElement(Dialog.ButtonFooter.CancelButton, {
        onClick: handleViewProfile
    }, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:roomPage.hostActions.viewProfile'
        }
    })), /*#__PURE__*/ React.createElement(Dialog.ButtonFooter.ConfirmButton, {
        onClick: handleKick
    }, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:roomPage.hostActions.kick'
        }
    }))));
}
